module.exports = __webpack_public_path__ + "img/yo-1.55e3409e.webp";